module.exports = __webpack_public_path__ + "img/洛阳白马集团有限责任公司.de50b169.jpg";